import BaseService from "./BaseService";

export default class NetworkService extends BaseService {
    
    public static getAllNetworksList(token: string, postData: any, countryId: string | null) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}biller/all-network-list/${countryId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static updateNetworkList(token: string, postData: any) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}biller/update-network-list`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

}